module.exports = __webpack_public_path__ + "img/icon-arrow-up.0121838a.svg";